module.exports = __webpack_public_path__ + "static/[edgeinnovationcenter.com][523]3-6-fdc76656b92402588570453b3b467e55.jpg";